// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"239":"blog","443":"about"}[chunkId] + "." + {"239":"b4194c27","443":"1cb0615c"}[chunkId] + ".js";
};